<template>
  <div class="guide">
    <div class="guideHeader">
      <div class="headerContainer">
        <div class="headerTitle">راهنما</div>
        <div class="backBtn" @click="closeGuideHandler">
          <i class="fas fa-arrow-left" style="font-size: 24px"></i>
        </div>
      </div>
    </div>
    <div class="guideMain">
      <div class="mainVideosList">
        <div class="videoThumb" v-for="(v, i) in $store.state.c_set.guide_value" :key="i">
          <div class="thumbTitle">{{v.property_title}}</div>
          <div class="thumbVideo" v-html="v.property_link">

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "guidePage",
  methods: {
    closeGuideHandler() {
      this.$emit("close");
      history.back();
    },
    handleBackBtn() {
      this.$emit("close");
    },
  },
  mounted() {
    window.addEventListener("popstate", this.handleBackBtn);
  },
  beforeUnmount() {
    window.removeEventListener("popstate", this.handleBackBtn);
  },
};
</script>
